// extracted by mini-css-extract-plugin
module.exports = {"appTappContent":"app-tapp_appTappContent__7Qlso","appTappContentActive":"app-tapp_appTappContentActive__8evfn"};